import { animate, animateChild, query, style, transition, trigger } from '@angular/animations';
import { MuiAnimationTiming } from '@move/ui';

export const animationTriggerMetadata = trigger('routeAnimations', [
    transition('* <=> *', [
        query(':enter', [
            style({ transform: 'translateY(1rem)', opacity: 0 }),
            animate(MuiAnimationTiming.EASE_OUT, style({ transform: 'none', opacity: 1 })),
            animateChild()
        ], { optional: true })
    ])
]);
